import { ReactElement } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { Chip, Tooltip } from '@mui/material'

interface Props {
  label: string
  hidden: boolean
  onToggleHidden: () => void
  onRemove: () => void
  'data-cy'?: string
}

/**
 * A chip for what the chat shows in the scene (marked elements, findings): a click on it hides
 * or shows it again (the eye), the x removes it.
 */
const SceneOverlayChip = ({
  label,
  hidden,
  onToggleHidden,
  onRemove,
  'data-cy': dataCy,
}: Props): ReactElement => (
  <Tooltip
    title={hidden ? 'In der Szene einblenden' : 'In der Szene ausblenden'}
    disableInteractive
  >
    <Chip
      size="small"
      color={hidden ? 'default' : 'primary'}
      variant="outlined"
      icon={hidden ? <VisibilityOffIcon /> : <VisibilityIcon />}
      label={label}
      onClick={onToggleHidden}
      onDelete={onRemove}
      sx={{ alignSelf: 'flex-start', mb: 1 }}
      data-cy={dataCy}
    />
  </Tooltip>
)

export default SceneOverlayChip
